<template>
  <Accordion :error="$v.nfse.taxes.$error" id="taxes" title="IMPOSTOS">
    <b-row class="row-padding align-items-end pt-0">
      <b-col md="6" lg="4">
        <SelectIssExibility
          :disabled="disabled"
          :default="true"
          :clearable="false"
          v-model="nfse.taxes.issExibility"
        />
      </b-col>
      <b-col md="6" lg="2">
        <SelectResponsibleRetention
          :disabled="disabled"
          :default="true"
          :clearable="false"
          v-model="nfse.taxes.responsibleRetention"
        />
      </b-col>
      <b-col>
        <Label>Local da prestação do serviço</Label>
        <b-row>
          <b-col md="6" lg="4">
            <SelectUf
              label=""
              :cityCode="cityCode"
              :disabled="disabled"
              v-model="nfse.taxes.uf"
            />
          </b-col>
          <b-col md="6" lg="8">
            <SelectCity
              label=""
              :disabled="disabled"
              :resizeSearchField="false"
              :uf="uf"
              :cityCode="cityCode"
              v-model="nfse.taxes.city"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col lg="2" class="text-center">
        <b-col><Label>ISS Retido</Label></b-col>
        <b-row>
          <b-col>
            <CheckboxSwitch
              id="issRetido"
              :disabled="disabled"
              v-model="nfse.taxes.retainedIss"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="row-padding">
      <b-col md="6" lg="2">
        <InputMoney
          label="COFINS (%)"
          :disabled="disabled"
          :precision="2"
          :prefix="false"
          :onKeyup="taxesDebounce"
          :max="6"
          v-model="nfse.taxes.cofinsPercentage"
        />
      </b-col>
      <b-col md="6" lg="2">
        <InputMoney
          label="COFINS (R$)"
          disabled
          :prefix="false"
          :precision="2"
          :value="nfse.taxes.cofinsValue"
        />
      </b-col>
      <b-col md="6" lg="2">
        <InputMoney
          label="PIS (%)"
          :disabled="disabled"
          :prefix="false"
          :precision="2"
          :onKeyup="taxesDebounce"
          :max="6"
          v-model="nfse.taxes.pisPercentage"
        />
      </b-col>
      <b-col md="6" lg="2">
        <InputMoney
          disabled
          label="PIS (R$)"
          :prefix="false"
          :precision="2"
          :value="nfse.taxes.pisValue"
        />
      </b-col>
      <b-col md="6" lg="2">
        <InputMoney
          label="INSS (%)"
          :disabled="disabled"
          :prefix="false"
          :precision="2"
          :onKeyup="taxesDebounce"
          :max="6"
          v-model="nfse.taxes.inssPercentage"
        />
      </b-col>
      <b-col md="6" lg="2">
        <InputMoney
          disabled
          label="INSS (R$)"
          :prefix="false"
          :precision="2"
          :value="nfse.taxes.inssValue"
        />
      </b-col>
    </b-row>
    <b-row class="row-padding pt-0">
      <b-col md="6" lg="2">
        <InputMoney
          label="IR (%)"
          :disabled="disabled"
          :prefix="false"
          :precision="2"
          :onKeyup="taxesDebounce"
          :max="6"
          v-model="nfse.taxes.irPercentage"
        />
      </b-col>
      <b-col md="6" lg="2">
        <InputMoney
          disabled
          label="IR (R$)"
          :prefix="false"
          :precision="2"
          :value="nfse.taxes.irValue"
        />
      </b-col>
      <b-col md="6" lg="2">
        <InputMoney
          label="CSLL (%)"
          :disabled="disabled"
          :prefix="false"
          :precision="2"
          :onKeyup="taxesDebounce"
          :max="6"
          v-model="nfse.taxes.csllPercentage"
        />
      </b-col>
      <b-col md="6" lg="2">
        <InputMoney
          disabled
          label="CSLL (R$)"
          :prefix="false"
          :precision="2"
          :value="nfse.taxes.csllValue"
        />
      </b-col>
      <b-col md="6" lg="2">
        <InputMoney
          label="ISS (%)"
          :disabled="disabled"
          :prefix="false"
          :precision="2"
          :onKeyup="taxesDebounce"
          :max="6"
          v-model="nfse.taxes.issPercentage"
        />
      </b-col>
      <b-col md="6" lg="2">
        <InputMoney
          disabled
          label="ISS (R$)"
          :prefix="false"
          :precision="2"
          :value="nfse.taxes.issValue"
        />
      </b-col>
    </b-row>

    <b-row class="row-padding align-items-end pt-0 justify-content-md-end">
      <b-col md="6" lg="2">
        <InputMoney
          label="Outras Retenções:"
          :disabled="disabled"
          :onKeyup="taxesDebounce"
          :precision="2"
          :max="17"
          v-model="nfse.taxes.otherRetentionsValue"
        />
      </b-col>
      <b-col md="6" lg="2">
        <InputDiscount
          label="Desconto:"
          :disabled="disabled"
          :precision="2"
          :onKeyup="discountDebounce"
          :type="nfse.taxes.discountType"
          :max="18"
          @changeDiscount="changeDiscount"
          v-model="nfse.taxes.discount"
        />
      </b-col>
      <b-col md="6" lg="2">
        <InputMoney
          label="Deduções Base de Cálc.:"
          :disabled="disabled"
          :onKeyup="taxesDebounce"
          :precision="2"
          :max="17"
          v-model="nfse.taxes.deductionsValue"
        />
      </b-col>
      <b-col md="6" lg="2">
        <InputMoney
          label="Base de Cálculo:"
          disabled
          :precision="2"
          :value="nfse.taxes.calculationBasis"
          :error="$v.nfse.taxes.calculationBasis.$error"
        />
      </b-col>
      <b-col md="6" lg="2">
        <InputMoney
          label="Total dos Serviços:"
          disabled
          :precision="2"
          :value="servicesValue"
        />
      </b-col>

      <b-col md="6" lg="2">
        <InputMoney
          label="Total da Nota:"
          disabled
          :precision="2"
          :value="total"
        />
      </b-col>
    </b-row>
  </Accordion>
</template>

<script>
import {
  Accordion,
  SelectResponsibleRetention,
  SelectIssExibility,
  SelectCity,
  SelectUf,
  InputDiscount,
} from '@/components';
import { Label, InputMoney, CheckboxSwitch } from '@/components/Form';
import { mapActions, mapState } from 'vuex';
import { CalcTypesNFSeEnum } from '@/modules/Fiscal/enums/CalcTypesEnum';
import { requiredCalculationBasis } from '@/reusable/validations';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import * as _ from 'lodash';

export default {
  name: 'taxCalc',
  mixins: [FormatMixin],
  components: {
    Accordion,
    Label,
    InputMoney,
    SelectCity,
    CheckboxSwitch,
    SelectResponsibleRetention,
    SelectIssExibility,
    SelectUf,
    InputDiscount,
  },
  validations: {
    nfse: {
      taxes: {
        calculationBasis: { requiredCalculationBasis },
      },
    },
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('nfse', ['nfse']),
    ...mapState('nfseConfigurations', ['nfseConfigurations']),

    servicesValue() {
      return `R$ ${this.valorReal(this.nfse.taxes.servicesValue)}`;
    },
    total() {
      return `R$ ${this.valorReal(this.nfse.taxes.total)}`;
    },
    uf() {
      return this.nfse.taxes.uf?.sigla ?? null;
    },
    cityCode() {
      return this.nfse.taxes?.city?.code ?? null;
    },
  },
  created() {
    this.taxesDebounce = _.debounce(async () => {
      await this.calculateNfse([
        CalcTypesNFSeEnum.TOTAL_SERVICES,
        CalcTypesNFSeEnum.TAXES_BASED_ON_TOTAL,
        CalcTypesNFSeEnum.TOTAL_NF,
      ]);
    }, 1500);

    this.discountDebounce = _.debounce(async () => {
      await this.calculateNfse([
        CalcTypesNFSeEnum.TOTAL_SERVICES,
        CalcTypesNFSeEnum.DISCOUNT_BASED_ON_TOTAL,
        CalcTypesNFSeEnum.TOTAL_NF,
      ]);
    }, 1500);
  },
  methods: {
    ...mapActions('nfse', ['calculateNfse']),

    async changeDiscount(data) {
      const { discountType } = this.nfse.taxes;

      if (discountType !== data) {
        this.nfse.taxes.discountType = data;
        await this.calculateNfse([
          CalcTypesNFSeEnum.TOTAL_SERVICES,
          CalcTypesNFSeEnum.DISCOUNT_BASED_ON_TOTAL,
          CalcTypesNFSeEnum.TOTAL_NF,
        ]);
      }
    },
  },
};
</script>
